<!-- @Description 工业级智能体-产品分类详情 -->
<template>
  <div class="manufacture-category-detail" v-if="category">
    <div
      class="category-header"
      :class="`category-header-bg${category.bgType}`"
    >
      <div class="back-bar" @click="goBack">
        <img :src="arrowIcon" class="back-arrow" alt="" />
        <span>返回产品矩阵</span>
      </div>
      <div class="category-title">{{ category.title }}</div>
    </div>
    <div class="product-section">
      <van-tabs
        v-model="activeIndex"
        class="product-tabs"
        :class="{ 'product-tabs--single': category.products.length === 1 }"
        :ellipsis="false"
      >
        <van-tab
          v-for="(product, index) in category.products"
          :key="`tab-${index}`"
          :title="product.title"
          :name="index"
        />
      </van-tabs>
      <div class="product-content" v-if="currentProduct">
        <div class="info">{{ currentProduct.info }}</div>
        <img
          :src="currentProduct.image"
          :alt="currentProduct.alt"
          class="product-img"
        />
        <div class="superiority">
          <div class="superiority-label">产品价值</div>
          <div
            class="superiority-item"
            v-for="(adv, advIndex) in currentProduct.advantages"
            :key="`adv-${activeIndex}-${advIndex}`"
          >
            <img :src="superiorityIcon" alt="重要性标志" />
            <span>{{ adv }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import arrowIcon from "@/../static/img/other/arrow.svg";
import { getCategoryByKey, superiorityIcon } from "./categoryData";
import { applyPageMeta } from "@/utils/pageMeta";

export default {
  name: "manufacture-category-detail",
  data() {
    return {
      arrowIcon,
      superiorityIcon,
      activeIndex: 0,
      category: null
    };
  },
  computed: {
    currentProduct() {
      if (!this.category) return null;
      return this.category.products[this.activeIndex];
    }
  },
  created() {
    this.loadCategory();
  },
  watch: {
    "$route.params.key"() {
      this.loadCategory();
    }
  },
  methods: {
    loadCategory() {
      const category = getCategoryByKey(this.$route.params.key);
      if (!category) {
        this.$router.replace({ name: "product_manufacture" });
        return;
      }
      this.category = category;
      this.activeIndex = 0;
      const intro = category.products[0] && category.products[0].info;
      applyPageMeta({
        title: category.title + "-工业级智能体-华院计算",
        description: intro || category.title,
        path: this.$route.path
      });
    },
    goBack() {
      this.$router.push({ name: "product_manufacture" });
    }
  }
};
</script>
<style lang="less" scoped>
.manufacture-category-detail {
  width: 100%;
  padding: 96px 0 0;
  min-height: calc(100vh - 96px);
  background: #f0f2f5;
  .category-header {
    position: relative;
    width: 100%;
    height: 200px;
    overflow: hidden;
    &.category-header-bg1 {
      background: url("../../../../static/img/product/product_society_arithmetic_bg1.png")
        no-repeat left center / 100%;
    }
    &.category-header-bg2 {
      background: url("../../../../static/img/product/product_society_arithmetic_bg2.png")
        no-repeat left center / 100%;
    }
    .back-bar {
      position: absolute;
      top: 16px;
      left: 32px;
      display: flex;
      align-items: center;
      font-size: 22px;
      color: #545a89;
      line-height: 32px;
      cursor: pointer;
      z-index: 1;
      .back-arrow {
        height: 14px;
        width: auto;
        margin-right: 8px;
        transform: rotate(180deg);
        opacity: 0.72;
      }
    }
    .category-title {
      height: 200px;
      line-height: 200px;
      font-size: 32px;
      color: #08204d;
      text-align: center;
    }
  }
  .product-section {
    width: 100%;
    background: #ffffff;
  }
  .product-tabs {
    height: 94px;
    /deep/.van-tabs__wrap {
      height: 94px;
      .van-tab__text {
        height: 100%;
        font-size: 26px;
        font-weight: 600;
        line-height: 94px;
        color: #08204d;
      }
    }
    /deep/.van-tab--active > span {
      color: #4256f1 !important;
    }
    /deep/.van-tabs__line {
      background-color: #4256f1;
    }
    /deep/.van-tab {
      flex: none !important;
      margin: 0 20px;
    }
    /deep/.van-tab:first-child {
      margin: 0 20px 0 40px;
    }
    /deep/.van-tab:last-child {
      margin: 0 40px 0 20px;
    }
    &.product-tabs--single {
      /deep/.van-tabs__nav {
        justify-content: center;
      }
      /deep/.van-tab:first-child,
      /deep/.van-tab:last-child {
        margin: 0 20px;
      }
    }
  }
  .product-content {
    padding: 24px 64px 32px;
    background: #ffffff;
    .info {
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      text-align: justify;
    }
    .product-img {
      width: 100%;
      margin: 24px 0;
      display: block;
    }
    .superiority {
      margin-bottom: 8px;
      .superiority-label {
        font-size: 26px;
        color: #08204d;
        line-height: 36px;
        margin-bottom: 20px;
        font-weight: 600;
      }
      .superiority-item {
        display: flex;
        font-size: 24px;
        color: #08204d;
        line-height: 32px;
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
        > img {
          width: 32px;
          height: 32px;
          margin-right: 16px;
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/manufacture/categoryDetail.vue